/* assets/section-product-faq.js */
(() => {
  'use strict';

  const SECTION_SEL = '.product-faq';
  const QUESTION_SEL = '[data-product-faq-question]';
  const ANSWER_SEL = '[data-product-faq-answer]';
  const ANSWER_INNER_SEL = '[data-product-faq-answer-inner]';

  function getAnswerHeight(answer) {
    const inner = answer.querySelector(ANSWER_INNER_SEL);
    return inner ? inner.offsetHeight : 0;
  }

  function setExpanded(question, expanded) {
    const answer = question.nextElementSibling;
    if (!answer || !answer.matches(ANSWER_SEL)) return;

    question.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    answer.classList.toggle('is-open', expanded);
    answer.style.height = expanded ? `${getAnswerHeight(answer)}px` : '0px';
  }

  function onClick(event, root) {
    const question = event.target.closest(QUESTION_SEL);
    if (!question || !root.contains(question)) return;

    event.preventDefault();
    const isExpanded = question.getAttribute('aria-expanded') === 'true';
    setExpanded(question, !isExpanded);
  }

  function syncOpenHeights(root) {
    root.querySelectorAll(`${QUESTION_SEL}[aria-expanded="true"]`).forEach((question) => {
      const answer = question.nextElementSibling;
      if (!answer || !answer.matches(ANSWER_SEL)) return;
      answer.style.height = `${getAnswerHeight(answer)}px`;
    });
  }

  function applyDefaultState(root) {
    root.querySelectorAll(QUESTION_SEL).forEach((question, index) => {
      setExpanded(question, index === 0);
    });
  }

  function init(root) {
    if (!root || root.dataset.productFaqReady === 'true') return;
    root.dataset.productFaqReady = 'true';

    root._productFaqOnClick = (event) => onClick(event, root);
    root.addEventListener('click', root._productFaqOnClick);

    root._productFaqOnResize = () => syncOpenHeights(root);
    window.addEventListener('resize', root._productFaqOnResize);

    applyDefaultState(root);
  }

  function destroy(root) {
    if (!root) return;

    if (root._productFaqOnClick) {
      root.removeEventListener('click', root._productFaqOnClick);
      delete root._productFaqOnClick;
    }

    if (root._productFaqOnResize) {
      window.removeEventListener('resize', root._productFaqOnResize);
      delete root._productFaqOnResize;
    }

    delete root.dataset.productFaqReady;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SECTION_SEL).forEach(init);
  }

  function destroyAll(scope) {
    (scope || document).querySelectorAll(SECTION_SEL).forEach(destroy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyAll(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest(SECTION_SEL);
    if (!root) return;
    const item = event.target.closest('.product-faq__item');
    if (!item) return;
    const question = item.querySelector(QUESTION_SEL);
    if (!question) return;
    setExpanded(question, true);
  });
})();
